import { AppHolder } from './AppHolder.js';

class CheckoutDialog {
    static show(opts, name = 'default') {
        AppHolder.getInstance(name).showCheckoutDialog(opts);
    }
    static hide(name = 'default') {
        AppHolder.getInstance(name).hideCheckoutDialog();
    }
}

export { CheckoutDialog };
